// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app-sidebar[data-v-38a10426]{display:flex}#tab-participants[data-v-38a10426]{margin-top:10px;padding-top:0;outline:none}[data-v-38a10426] .app-sidebar-tabs{height:calc(100% - 80px)}[data-v-38a10426] .app-sidebar-tabs__content{overflow:hidden}[data-v-38a10426] .app-sidebar-tabs__content section{height:100%;overflow-y:auto}.app-sidebar-tabs__content #tab-chat[data-v-38a10426]{padding:0}\n", ""]);
// Exports
module.exports = exports;
